
//Modules
import { ReactElement , useEffect , useState } from "react";
import { Modal , Box , IconButton , Typography, Paper } from "@mui/material";

//Utils
import { formatYears } from "../../utils/utility";
import { findModel } from "../../api/fetch";
//Interface
import { i_fit_modal_props } from "../../interfaces/utility.interface";


//Icons
import CloseIcon from '@mui/icons-material/Close';
import { i_car_fit } from "../../interfaces/items.interface";

const FitModal = ( props : i_fit_modal_props ) : ReactElement => {
    const [ data , setData ] = useState<i_car_fit[]>([])
    const [ loading , setLoading ] = useState(false)
    useEffect(() => {
        const handleFitement = async() => {
            const new_fitments = []
            for(var x = 0; x < props.fit.length; x++){
                const make = props.makes.find(make => make._id === props.fit[x].make_id)
                const model =  await findModel(props.fit[x].model_id)
                const years = props.fit[x].years
                if(model.length === 0 || make === undefined){
                    continue;
                }
                const new_item = { make : make.name , model : model[0].name , years : years , make_id : props.fit[x].make_id , model_id : model[0]._id}
                new_fitments.push(new_item)
            }
            setData(new_fitments)
            setLoading(false)
        }
        if(props.fit !== null){
            setLoading(true)
            handleFitement()
        }
    },[props.fit])
    const match = ( item : any) : boolean => {
        if(props.filter !== undefined){
            if(props.filter.make_id === item.make_id && props.filter.model_id === item.model_id ){
                return true
            }else{
                return false
            }
        }
        return false
    }
    return (
    <Modal open={props.fit !== null} onClose={() => props.clear()}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100vw', }} >
            <Paper sx={{ position: 'relative',  boxShadow: 24, p: 2, borderRadius: 2, maxWidth: '90%', minWidth : 600, minHeight : 200, maxHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', }} >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Typography variant="h6">Part Compatiblity.</Typography>
                    <IconButton onClick={() => props.clear()}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                {loading ?
                    <Box>...loading</Box>
                    :
                    <Box>
                        {data.map(( fit : any, index : number) => (
                            <Box key={index} sx={{ padding : 0.5 , border : '1px solid #EAECF0' , backgroundColor : match(fit) ? 'lime' : 'initial' }}>
                                <Typography sx={{ fontSize : 18 , textDecoration : 'underline'}}>{fit.make} - {fit.model} - {formatYears(fit.years)}</Typography>
                            </Box>
                        ))}
                    </Box>
                }
            </Paper>
        </Box>
    </Modal>
    )
}

export default FitModal;